import { render, staticRenderFns } from "./SoliStudents.vue?vue&type=template&id=4a2f9a0d&scoped=true"
import script from "./SoliStudents.vue?vue&type=script&lang=js"
export * from "./SoliStudents.vue?vue&type=script&lang=js"
import style0 from "./SoliStudents.vue?vue&type=style&index=0&id=4a2f9a0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2f9a0d",
  null
  
)

export default component.exports